import React, { Component } from 'react';
import { Divider, Button } from 'antd';
import { Grid, Row, Col } from 'react-flexbox-grid';
import FormCreateResto from '../../FormCreateResto';
import FormSendPushsToUsers from '../../FormSendPushsToUsers';
import { cloudFunctions, db } from '../../../config/Fire';
import * as Constants from '../../../constants/nodes_database';
import * as ConstantsState from '../../../constants/reserve';
import moment from 'moment';
import './styles.css';

class Home extends Component {
    generateDeepLinks = () => {
        console.log("Generando deeplinks...")
        cloudFunctions.generateDeepLinksRestos().then(() => {
            console.log("Deeplinks generados");
        }).catch((err) => {
            console.log("Deeplinks error " + err);
        });
    }

    updateReservations = () => {
        console.log("update reservations...")
        db.ref(`${Constants.RESERVATIONS}`).once("value")
        .then(reserveSnap => {
            const promisesUpdateReservations = [];
            if(reserveSnap.exists()) {
                reserveSnap.forEach((reservationSnap) => {
                    var reserve = reservationSnap.val();
                    if(reserve.reservationId !== null && reserve.reservationId !== "" && reserve.users === undefined) {
                        var usersInReservations = [];
                        var userOwner = {
                            id: "",
                            email: "",
                            phone: "",
                            dni: "",
                            firstName: "",
                            lastName: "",
                            street: "",
                            city: "",
                            province: "",
                            country: "",
                            assisted: false,
                            temperature: "",
                            checkInRestaurant: "",
                            checkOutRestaurant: "",
                            reserveOwner: false,
                            joinedByRestaurant: false,
                            reserveCommented: false,
                            profilePicture: ""
                        };
                        userOwner.id = reserve.user.userId;
                        userOwner.profilePicture = `users/imageProfile/${reserve.user.userId}/profile`;
                        userOwner.email = reserve.user.userEmail ? reserve.user.userEmail : "";
                        userOwner.phone = reserve.user.userPhone ? reserve.user.userPhone : "";
                        userOwner.dni = "";
                        userOwner.firstName = reserve.user.userName ? reserve.user.userName : "";
                        userOwner.lastName = "";
                        userOwner.street = "";
                        userOwner.city = "";
                        userOwner.province = "";
                        userOwner.country = "";
                        userOwner.reserveOwner = true;
                        if(reserve.state === ConstantsState.RESERVE_STATE.assisted) {
                            userOwner.assisted = true
                        }
                        usersInReservations.push(userOwner)
                        const updateReservationRef = db.ref(`${Constants.RESERVATIONS}`).child(`${reserve.reservationId}`).update({
                            users: usersInReservations
                        })
                        promisesUpdateReservations.push(updateReservationRef)
                        const updateReservationByUserRef = db.ref(`${Constants.RESERVATIONS_BY_USER}`).child(`${reserve.user.userId}`).child(`${reserve.reservationId}`).set({
                            reservationId: reserve.reservationId,
                            date: reserve.date,
                            hour: reserve.hour,
                            restoName: reserve.restoName,
                            peopleCount: reserve.peopleCount,
                            inviteDeeplink: reserve.inviteDeeplink ? reserve.inviteDeeplink : "",
                            restoAddress: reserve.restoAddress,
                            state: reserve.state,
                            dateInteger: reserve.dateInteger,
                            assisted: (reserve.state === ConstantsState.RESERVE_STATE.assisted),
                            reserveOwner: true,
                            discount: reserve.discount ? reserve.discount : "",
                            restoId: reserve.restoId,
                            reserveCommented: reserve.isCommented ? reserve.isCommented : false
                        })
                        promisesUpdateReservations.push(updateReservationByUserRef)
                    }
                })
            }
            return Promise.all(promisesUpdateReservations)
            .then(() => {
                console.log("update reservations successfuly")
            })
            .catch(err => {
                console.log("Promises error!" + JSON.stringify(err))
            })
        })
        .catch(err => {
            console.log("Error!" + JSON.stringify(err))
            console.log(err)
        })
    }

    actualizeRestos = () => {
        console.log("Actualizando...")
        cloudFunctions.actualizeRestos().then((result) => {
            console.log("Restaurantes actualizados: " +  JSON.stringify(result));
        }).catch((err) => {
            console.log("Restaurantes error " + err);
        });
    }

    actualizeReservations = () => {
        console.log("Actualizando...")
        cloudFunctions.actualizeReservations().then((result) => {
            console.log("Reservas actualizadas: " + JSON.stringify(result));
        }).catch((err) => {
            console.log("Reservas error " + err);
        });
    }

    sendPushToComment = () => {
        console.log("Actualizando...")
        cloudFunctions.notifyAssistedReservations().then((result) => {
            console.log("Reservas actualizadas: " + JSON.stringify(result));
        }).catch((err) => {
            console.log("Reservas error " + err);
        });
    }

    render() {
        return (
            <Grid className="homeAdminCont">
                <Divider>Crear restaurante</Divider>
                <Row center="xs">
                    <Col xs={12} sm={10} md={6}>
                        <FormCreateResto />
                    </Col>
                </Row>
                <Divider>Mensajería para usuarios</Divider>
                <Row center="xs">
                    <Col xs={12} sm={10} md={6}>
                        <FormSendPushsToUsers />
                    </Col>
                </Row>
                {/*<Row center="xs">
                    <Col xs={12}>
                        <Button onClick={this.generateDeepLinks}>Generar deeplinks</Button>
                    </Col>
                </Row>*/}
                {/* {<Row center="xs">
                    <Col xs={12}>
                        <Button onClick={this.updateReservations}>Actualizar reservas</Button>
                    </Col>
                </Row>} */}
                {/* {<Row center="xs">
                    <Col xs={12}>
                        <Button onClick={this.sendPushToComment}>Mandar pushs</Button>
                    </Col>
                </Row>} */}
                {
                    /*<Row center="xs">
                        <Col xs={12}>
                            <Button onClick={this.updateReservations}>actualizar reservas</Button>
                        </Col>
                    </Row>*/
                }
                {/*<Row center="xs">
                    <Col xs={12}>
                        <Button onClick={this.actualizeRestos}>Actualizar restaurantes</Button>
                    </Col>
            </Row>*/}
            {/*<Row center="xs">
                    <Col xs={12}>
                        <Button onClick={this.actualizeReservations}>Actualizar reservas</Button>
                    </Col>
        </Row>*/}
            </Grid>
        );
    }
}

Home.propTypes = {

};

export default Home;